// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// const WhatsAppChatButton = () => {
//   const whatsappNumber = "+919398355147"; // Replace with your WhatsApp number
//   const whatsappMessage = "Hello! I need help with..."; // Default message, can be customized
//   const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
//     whatsappMessage
//   )}`;

//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         bottom: "20px",
//         right: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <IconButton
//         href={whatsappUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         sx={{
//           backgroundColor: "#25D366", // WhatsApp green
//           color: "#fff",
//           "&:hover": {
//             backgroundColor: "#128C7E", // Darker green on hover
//           },
//           width: "60px",
//           height: "60px",
//           boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <WhatsAppIcon sx={{ fontSize: 40 }} />
//       </IconButton>
//       <Typography
//         sx={{
//           position: "absolute",
//           bottom: "10px",
//           right: "70px",
//           backgroundColor: "#25D366",
//           color: "#fff",
//           padding: "5px 10px",
//           borderRadius: "10px",
//           whiteSpace: "nowrap",
//           boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//           display: { xs: "none", md: "block" }, // Hide on small screens
//         }}
//       >
//         Need Help? Chat with us
//       </Typography>
//     </Box>
//   );
// };

// export default WhatsAppChatButton;

import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppChatButton = () => {
  const whatsappNumber = "+14255242725"; // Replace with your WhatsApp number
  const whatsappMessage = "Hello! I need help with..."; // Default message, can be customized
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
        "&:hover .hover-text": {
          display: "block",
          animation: "slideIn 0.3s ease-out forwards", // Slide-in animation on hover
        },
      }}
    >
      <IconButton
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          backgroundColor: "#25D366", // WhatsApp green
          color: "#fff",
          "&:hover": {
            backgroundColor: "orange", // Darker green on hover
            transform: "scale(1.1)", // Slight scale-up on hover
            transition: "all 0.3s ease",
          },
          width: "60px",
          height: "60px",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          animation: "pulse 1.5s infinite", // Pulsing animation
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 40 }} />
      </IconButton>
      <Typography
        className="hover-text"
        sx={{
          position: "absolute",
          bottom: "10px",
          right: "70px",
          backgroundColor: "orange",
          color: "#fff",
          padding: "5px 10px",
          borderRadius: "10px",
          whiteSpace: "nowrap",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          display: "none", // Hidden by default
          transition: "opacity 0.3s ease", // Smooth fade effect
        }}
      >
        Need Help? Chat with us
      </Typography>
    </Box>
  );
};

// Add keyframes for animations
const styles = `
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
  @keyframes slideIn {
    0% { transform: translateX(20px); opacity: 0; }
    100% { transform: translateX(0); opacity: 1; }
  }
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);

export default WhatsAppChatButton;
